﻿/* globals AlertsUiDto*/

import 'mailcheck';
import jquery from 'jquery';
import Functions from './functions';
import HabEvents from '../../Global/habitaclia-events';
import AlertsRepository from '../repositories/alerts-repository';

class AlertsUI {
    constructor(alertsUIDto) {

        this._alertsUIDto = alertsUIDto;
        this._$formAlerta = jquery('#' + this._alertsUIDto.selectorForm);
        this._$inputEmail = jquery('#' + this._alertsUIDto.selectorInputEmail);
        this._$inputFiltros = jquery('#'+ this._alertsUIDto.selectorFiltros);
        this._$inputEmailCajonAlerta = jquery('#js-email-cajonalerta');
        this._$inputFiltrosCajonAlerta = jquery('#js-filtros-cajonalerta');
        this._$buttonCajonAlerta = jquery('#js-button-cajonalerta');
        this._$checkLegal = jquery('#js-legal-check');
        this._$checkLegalInList = jquery('#js-legal-check-in-list');
        this._$checkFiltrosCajonAlerta = jquery('#idFiltros-alerta');
        this._$alertaOrigen = jquery('#id_alerta_origen_6');

        this._alertsRepository = new AlertsRepository({ UrlRegistrarAlerta: this._alertsUIDto.UrlRegistrarAlerta });
        this._registerEvents();
    }


    _registerEvents() {

        this._$formAlerta.on('submit', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this._registrarAlerta('#js-search-box','#js-response-alert');
        });


        this._$buttonCajonAlerta.on('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const email =  this._$inputEmailCajonAlerta.val();
            this._$inputEmail.val(email);
            this._$alertaOrigen.val('7');

            if(this._$inputFiltrosCajonAlerta.is(':checked')){
                this._$inputFiltros.attr('checked','checked');
            }
            if(this._$checkLegalInList.prop('checked')){
                this._$checkLegal.attr('checked', 'checked');
            }

            this._registrarAlerta('#js-search-box-cajonalerta','#js-response-cajonalerta');
        });
        this._$checkFiltrosCajonAlerta.change((event) => {
            event.target.value = event.target.checked ? 1 : 0;
        });
    }


    _registrarAlerta(containerAlert, containerResponse) {

        if(this._$inputEmail.val() === '' || !Functions.ValidateEmail(this._$inputEmail[0])){
            this._renderEmailNoValido();
        } else if (!this._alertsUIDto.isUserLogged && !this._$checkLegal.prop('checked')) {
            this._renderLegalNoValido();
        } else {
            jquery.publish(HabEvents.EventsEnum.RegistrarAlerta);
            jquery.publish(HabEvents.EventsEnum.AlertAdded);
            const $containerAlert = jquery(containerAlert);
            const $containerResponse = jquery(containerResponse);
            this._alertsRepository.registrarAlerta(this._$formAlerta)
                .then((data) => {
                    jquery.publish(HabEvents.EventsEnum.RegistrarAlertaOk);
                    jquery.publish(HabEvents.EventsEnum.AlertAddedSuccess);
                    $containerAlert.addClass('hide-none');
                    $containerResponse.html(data.description);
                    $containerResponse.removeClass('hide-none');
            });
        }
    }


    _renderEmailNoValido(){
       
        const error = (this._$inputEmail.val() === '') ? this._alertsUIDto.Translate.idErrBadMailEmpty : this._alertsUIDto.Translate.idErrBadMail;
        alert(error);
      
        jquery.publish(HabEvents.EventsEnum.ErroresForm, ['form-alerta_listados', 'Email incorrecto o no informado']);
    }


    _renderLegalNoValido(){
       
        const error = this._alertsUIDto.Translate.idErrUncheckedLegal;
        alert(error);
      
        jquery.publish(HabEvents.EventsEnum.ErroresForm, ['form-alerta_listados', 'Unchecked legal']);
    }


}


new AlertsUI(AlertsUiDto);